<script setup lang="ts">
  definePageMeta({
    middleware: ['company']
  })

  onBeforeMount(() => {
    const { fetchStore, getPages } = useStoreStore()
    const { applyLocale } = useAppLocale()

    const { companyId } = useStoreApp()
    fetchStore(companyId)
    getPages()

    applyLocale()

    window.addEventListener('message', function (event) {
      if (event.data.scroll) {
        const { scroll, vp } = event.data
        useStoreStore().scrollPosition = scroll ?? 0
        if (vp) useStoreStore().viewportHeight = vp
      } else if (event.data.modalHeight) {
        useStoreStore().modalHeight = event.data.modalHeight ?? 600
        useStoreStore().modalTop = event.data.modalTop ?? 0
      }
    })
  })
</script>

<template>
  <NuxtPage />
</template>
